import { Table2 } from "lucide-react";
import { DSD_REVIEW_COPY } from "../copy";

/** 셀을 고르기 전 패널 본문 — 점선 상자. message 가 있으면 선택 안내 대신 그 문구 (결과 없음 등) */
export const DsdReviewNoSelectionBox = ({ message }: { message?: string }) => (
  <div className="flex min-h-40 flex-col items-center justify-center gap-2 rounded-[8px] border border-dashed border-line-normal bg-slate-50 px-4 py-6 text-center">
    {message ? (
      <p className="body-2-normal-regular text-label-alternative">{message}</p>
    ) : (
      <>
        <Table2 className="size-6 text-label-assistive" />
        <div>
          <p className="caption-1-regular text-label-alternative">
            {DSD_REVIEW_COPY.matching.noSelectionCaption}
          </p>
          <p className="label-1-normal-medium text-label-normal">
            {DSD_REVIEW_COPY.matching.noSelection}
          </p>
        </div>
      </>
    )}
  </div>
);
